export default __webpack_public_path__ + "static/media/eyes_transparent.e69d36fb.svg";